// extracted by mini-css-extract-plugin
export default {"header":"styles_header_m7jmH","conflict":"styles_conflict_EJEBL","disaster":"styles_disaster_XP8Ix","numberHeader":"styles_number-header_iT5Mb","number":"styles_number_yj3JN"};